import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { yearMonthDay, getDates } from 'redux/reducers/calendar/utls.js'
import { onKeyDownAction } from 'redux/reducers/calendar/actions'
import Days from './Days'

const Weeks = ({ t }) => {
  const dispatch = useDispatch()
  const { date } = useSelector((state) => state.calendar)
  const weeks = getDates(date)

  const handleOnKeyDown = async (e) => {
    const key = await e.key.replace('Arrow', '')
    dispatch(onKeyDownAction(key))
  }

  return (
    <section id="Calendar-dates" onKeyDown={handleOnKeyDown} aria-label={t('calendar_schedular.calendar_dates')} role="application">
      {weeks.map((week) => {
        return (
          <div key={yearMonthDay(week[0])} className="Calendar-row">
            <Days week={week} />
          </div>
        )
      })}
    </section>
  )
}

export default withTranslation('common')(Weeks)
